// extracted by mini-css-extract-plugin
export default {"root":"Header_root__jiUBv","logo-box":"Header_logo-box__NCdMA","image-logo":"Header_image-logo__+JZlL","test-logo":"Header_test-logo__00mz3"};